import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import { trackingList } from 'src/utils/valueHTML';
import { getFontURL } from 'src/utils/getFontUrl';

const SimpleCardModalHTML: FC = () => {
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  let radius = useSelector((state: RootState) => state.imageUpload.radius);
  let deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);
  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  let tracking = useSelector((state: RootState) => state.trackings.tracking);
  let button1 = useSelector((state: RootState) => state.trackings.button1);
  let button2 = useSelector((state: RootState) => state.trackings.button2);
  let btnAgain = useSelector((state: RootState) => state.buttons.btnAgain);
  let bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );

  const backgroundDimmed = bgOpacity?.bgDimmed / 100;
  const displayValue = backgroundDimmed >= 0.01 ? backgroundDimmed : 0.7;

  const multiLeftButtonFontURL = getFontURL(btnFontFamily?.multi_left_button);
  const multiRightButtonFontURL = getFontURL(btnFontFamily?.multi_right_button);

  const style = `
   @font-face {
      font-family: "multiLeftButton";
      src: url(${multiLeftButtonFontURL});
    }
    @font-face {
      font-family: "multiRightButton";
      src: url(${multiRightButtonFontURL});
    }

    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;
      position: relative;
      background: none;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .background {
     width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, ${displayValue});
    }
    .modal-wrapper {
      position: relative;
      width: 314px;
      height: auto;
      display: flex;
      flex-direction: column;      
    }
    .image-wrapper {
      width: 100%;
      max-height: 582px;
      height: auto;
      display: flex;   
         
    }
    .image {
      width: 100%;
      height: auto;
      object-fit: cover;
      object-position: top;
      border-radius: ${radius?.multi_image}px ${radius?.multi_image}px 0px 0px;
    }
    .btn-wrapper {
      width: 100%;
      height: 48px;
      padding: 0px 15px;
      background-color: ${bgColor?.background};
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
     .btn-wrapper button {
      border: 0;
      background-color: transparent;
    }
    .btn-wrapper .style01, .btn-wrapper .style02 {
      width: 100%;
      height: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      background-color: transparent;
    }
    .btn-wrapper .style01 {
      font-size: ${btnFontSize?.multi_left_button}rem;
      font-weight: ${btnFontWeight?.multi_left_button};
      color: ${btnColor?.multi_left_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_left_button
        )
          ? btnFontFamily.multi_left_button
          : 'multiLeftButton'
      };
      text-align: left;
    }
    .btn-wrapper .style02 {
      font-size: ${btnFontSize?.multi_right_button}rem;
      font-weight: ${btnFontWeight?.multi_right_button};
      color: ${btnColor?.multi_right_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_right_button
        )
          ? btnFontFamily.multi_right_button
          : 'multiRightButton'
      };
      text-align: right;
    }
    .swiper-container {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
    }
    .swiper-pagination {
      position: absolute;
			bottom: 10px;
      left: 0;
      right: 0;
      z-index: 10;
    }
    .swiper-pagination-bullet {
      background: #000000; /* 페이지네이션 점의 색상 */
      opacity: 0.5;
    }
    .swiper-pagination-bullet-active {
      opacity: 1;
    }
    .swiper-wrapper {
      align-items: flex-start; /* 추가 */
    }
    .swiper-slide {
      width: 100%;
      height: auto; /* 추가 */
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 0;
    }
    .swiper-container-initialized .swiper-pagination {
      display: flex;
    }
    .swiper-container-initialized.swiper-container-horizontal.swiper-container-lock .swiper-pagination {
      display: none;
    }
  `;

  const deeplink_list = JSON.stringify(deeplink?.multi_image);
  const button_list = JSON.stringify(
    (bgImage?.multi_image).map((_, i) => [
      btnText?.multi_left_button?.[i] || '',
      btnText?.multi_right_button?.[i] || ''
    ])
  );

  const tracking_list = JSON.stringify(
    (tracking?.multi_image).map((image, i) => [
      image || '',
      tracking?.multi_left_button?.[i] || '',
      tracking?.multi_right_button?.[i] || ''
    ])
  );
  const html = `
    <div class="root">
     	<div class="background" onclick="appboyBridge.logClick('background'); appboyBridge.closeMessage();"></div>
      <div class="modal-wrapper">
				<div class="swiper-container">
				   <div class="swiper-wrapper">
            ${bgImage?.multi_image
              .map(
                (url, index) => `
              <div class="swiper-slide">
                <div class="image-wrapper">
                  <img
                    class="image"
                    src="${url}"
                    alt="modal-image-${index + 1}"
                  />
                </div>
              </div>
            `
              )
              .join('')}
          </div>
					<div class="swiper-pagination"></div>
				</div>
				<div class="btn-wrapper">
					<button class="style01"></button>
					<button class="style02"></button>
				</div>
			</div>
		</div>
		<div id="deeplink" style="display: none">${deeplink_list}</div>
  `;

  // let button_list = `[`;
  // for (let i = 0; i < bgImage?.multi_image?.length; i++) {
  //   button_list += `['${btnText?.multi_left_button?.[i]}', '${btnText?.multi_right_button?.[i]}']`;
  //   if (i !== btnText?.multi_image?.length - 1) button_list += ',';
  // }
  // button_list += ']';

  // let tracking_list = `[`;
  // for (let i = 0; i < tracking?.multi_image?.length; i++) {
  //   tracking_list += `['${tracking?.multi_image?.[i]}', '${tracking?.multi_left_button?.[i]}', '${tracking?.multi_right_button?.[i]}']`;
  //   if (i !== tracking?.multi_image?.length - 1) tracking_list += ',';
  // }
  // tracking_list += ']';

  let tracking_button_list = trackingList(
    'SIMPLE CARD MODAL',
    button1,
    button2
  );

  const js = `
    document.addEventListener("DOMContentLoaded", function () {
      let currentIndex = 0;
      let button_list = ${button_list};
			document.querySelector(".style01").textContent = button_list[currentIndex][0];
      document.querySelector(".style02").textContent = button_list[currentIndex][1];

			var swiper = new Swiper(".swiper-container", {
				slidesPerView: 1,
				loop: false,
				pagination: {
					el: ".swiper-pagination",					
				},
				watchOverflow: true,
				effect: "slide",
				speed: 400,
        on: {
					slideChange: function (swiper) {
						currentIndex = swiper.realIndex;
            document.querySelector(".style01").textContent = button_list[currentIndex][0];
            document.querySelector(".style02").textContent = button_list[currentIndex][1];
					},
				},
			});

			let content = document.getElementById("deeplink").textContent;
			let link = content.replace(/\\n|\\t/g, "").trim();
			let deeplink = JSON.parse(link);

			let tracking = ${tracking_list};
			let button1 = ${tracking_button_list[0]};
      let button2 = ${tracking_button_list[1]};
			
			
			
			document.querySelector(".image-wrapper").addEventListener("click", function () {
				try {
					appboyBridge.logClick(tracking[currentIndex][0]);
					if (button1[0].indexOf(currentIndex) !== -1) {
						appboyBridge.logClick("0");
					}
					if (button2[0].indexOf(currentIndex) !== -1) {
						appboyBridge.logClick("1");
					}
				} catch (err) {}
				window.location = deeplink[currentIndex];
			});

			document.querySelector(".style01").addEventListener("click", function () {
				try {
					appboyBridge.logClick(tracking[currentIndex][1]);
					if (button1[1].indexOf(currentIndex) !== -1) {
						appboyBridge.logClick("0");
					}
					if (button2[1].indexOf(currentIndex) !== -1) {
						appboyBridge.logClick("1");
					}
					if ("${btnAgain?.type}" === "attribute") {
						appboyBridge.getUser().setCustomUserAttribute("${btnAgain?.multi_left_button}", new Date());
					}
					if ("${btnAgain?.type}" === "event") {
						appboyBridge.logCustomEvent("${btnAgain?.multi_left_button}");
					}
				} catch (err) {}
				appboyBridge.closeMessage();
			});

			document.querySelector(".style02").addEventListener("click", function () {
				try {
					appboyBridge.logClick(tracking[currentIndex][2]);
					if (button1[2].indexOf(currentIndex) !== -1) {
						appboyBridge.logClick("0");
					}
					if (button2[2].indexOf(currentIndex) !== -1) {
						appboyBridge.logClick("1");
					}
				} catch (err) {}
				appboyBridge.closeMessage();
			});
		});
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          http-equiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta http-equiv="Expires" content="0" />
        <meta http-equiv="Pragma" content="no-cache" />

        {/* google font */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <link
          rel="stylesheet"
          href="https://unpkg.com/swiper@11/swiper-bundle.min.css"
        />
        <script src="https://unpkg.com/swiper@11/swiper-bundle.min.js"></script>
        <style dangerouslySetInnerHTML={{ __html: style }}></style>
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }}></body>
      <script dangerouslySetInnerHTML={{ __html: js }}></script>
    </>
  );
};
export default SimpleCardModalHTML;
